module.exports = __webpack_public_path__ + "static/media/Trainicon01@2x.a51853e3.png";